<script>
export default {
	name: "GridRenderer",
	props: {
		rows: {
			type: Number,
			default: null
		},
		rowHeight: {
			type: Number,
			default: null
		},
		columns: {
			type: Number,
			default: null
		},
		columnWidth: {
			type: Number,
			default: null
		}
	},
	computed: {
		rowStyle() {
			const rows = this.rows;
			if (rows) {
				return {
					gridTemplateRows: `repeat(${rows}, ${this.rowHeight}px)`
				}
			}
			return {
				gridAutoRows: `${this.rowHeight}px`
			}
		},
		colStyle() {
			const cols = this.columns;
			if (cols) {
				return {
					gridTemplateColumns: `repeat(${cols}, ${this.columnWidth}px)`
				}
			}
			return {
				gridAutoColumns: `${this.columnWidth}px`
			}
		},
		gridFlow() {
			let flow = {};
			if (!(this.rows && this.columns)) {
				if (this.rows) {
					flow['gridAutoFlow'] = 'column dense'
				} else {
					flow['gridAutoFlow'] = 'row dense'
				}
			}
			return flow;
		},
		style() {
			return {
				...this.rowStyle,
				...this.colStyle,
				...this.gridFlow
			}
		}
	}
}
</script>

<template>
	<div :style="style" class="grid-renderer">
		<slot />
	</div>
</template>

<style lang="scss" scoped>
.grid-renderer {
  display: grid;
}
</style>
